module.exports = __webpack_public_path__ + "img/cloud1C.png";